var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 h-100"},[_c('line-chart',{ref:"chart",attrs:{"data":_vm.linechart.data,"options":_vm.linechart.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }